module.exports = __webpack_public_path__ + "static/media/EAMA_Instructions.30562198.pdf";